import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "@redux-devtools/extension";
import counterReducer from "./slices/counter";
import common from "./slices/common";

export const store = configureStore(
  {
    reducer: {
      counter: counterReducer,
      common,
    },
  },
  composeWithDevTools()
);
